import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './getStyles';
import { IconColor } from './constants';

const CalloutTitleUnthemed = React.memo(({
  iconName,
  iconColor,
  text,
  classes,
}) => (
  <div className={classNames(classes.calloutTitle, 'callout-title')}>
    { iconName && <Glyphicon glyph={`ba-${iconName}`} className={classNames(classes.calloutTitleIcon, 'callout-title-icon')} style={{ color: iconColor || IconColor[iconName] }} /> }
    <div className="callout-title-text">{text}</div>
  </div>
));

CalloutTitleUnthemed.propTypes = {
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  text: PropTypes.string,
  classes: PropTypes.shape({}),
};

CalloutTitleUnthemed.defaultProps = {
  iconName: null,
  iconColor: null,
  text: null,
  classes: {},
};

export const CalloutTitle = withDefaultStyles(CalloutTitleUnthemed, getStyles);
